// import isoToDate from '@/utils/isoToDate';

function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
}

function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}

function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function getMMDD(d) {
    return getMM(d) + getDD(d);
}

function getMM(d) {
    return d.getMonth() + 1 + '月';
}

function getDD(d) {
    return d.getDate() + '日';
}

function getTimeAPM(d) {
    let hours = d.getHours();
    let minutes = d.getMinutes();
    let ampm =
        hours < 5 ? '凌晨' : hours < 12 ? '上午' : hours < 19 ? '下午' : '晚上';

    if (hours > 12) hours = hours % 12;
    // hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return ampm + hours + ':' + minutes;
}

export default function(d, format = 'date') {
    if (isString(d)) {
        //assume iso string
        d = new Date(d);
    }
    if (isNumber(d)) {
        //assume second in Instant: e.g 1548405011.71
        d = new Date(d * 1000);
    }
    if (!isValidDate(d)) {
        return '';
    }
    if (format === 'date') {
        return getMMDD(d);
    }
    if (format === 'fulldate') {
        return d.getFullYear() + '年' + getMMDD(d);
    }
    if (format === 'yearMonth') {
        return d.getFullYear() + '年' + getMM(d);
    }
    if (format === 'datetime') {
        return getMMDD(d) + getTimeAPM(d);
    }
    if (format === 'fullDateTime') {
        return d.getFullYear() + '年' + getMMDD(d) + ' ' + getTimeAPM(d);
    }
    if (format === 'dayOnlyDatetime') {
        return getDD(d) + ' ' + getTimeAPM(d);
    }
    //月日上午下午
}
